import React from 'react';
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  redirect,
} from 'react-router-dom';
import {
  HOTELS,
  MAIN,
  REPORTS,
  SERVICE,
  SALES,
  PROBLEMS,
  BILLING,
  OFFLINE_HEADSETS,
  HEADSETS,
  SETTINGS,
  METRICS,
  ANALYTICS,
  ABOUT,
  SUBSCRIPTION,
  EVENTS,
  USER_EVENTS,
  PAYMENTS,
  COMMENTS,
  META,
  ACCESS_DENIED,
  DEVICE_EVENTS,
  BATTERY_LOGS,
} from './constants';
import Layout from './pages/layout/layout';
import PageNotFound from './pages/pageNotFound/pageNotFound';
import AccessDeniedPage from './pages/accessDenied/accessDenied';
import AuthPage from './pages/authPage/authPage';
import MainPage from './pages/mainPage/mainPage';
import HotelsPage from './pages/hotelsPage/hotelsPage';

import ReportsSales from './pages/reports/reportsSales/reportsSales';
import ReportsProblems from './pages/reports/reportsProblems/reportsProblems';
import ReportsBilling from './pages/reports/reportsBilling/reportsBilling';
import ReportsOfflineHeadsets from './pages/reports/reportsOfflineHeadsets/reportsOfflineHeadsets';

import ServiceAnalytics from './pages/service/serviceAnalytics/serviceAnalytics';
import ServiceHeadsets from './pages/service/serviceHeadsets/serviceHeadsets';
import ServiceDeviceEvents from './pages/service/serviceDeviceEvents/serviceDeviceEvents';

import HotelHeadsets from './pages/hotels/hotelHeadsets/hotelHeadsets';
import HotelMetrics from './pages/hotels/hotelMetrics/hotelMetrics';
import HotelAnalytics from './pages/hotels/hotelAnalytics/hotelAnalytics';
import HotelBilling from './pages/hotels/hotelBilling/hotelBilling';
import HotelAbout from './pages/hotels/hotelAbout/hotelAbout';

import HeadsetSettings from './pages/headsets/headsetSettings/headsetSettings';
import HeadsetSubscriptions from './pages/headsets/headsetSubscriptions/headsetSubscriptions';
import HeadsetBilling from './pages/headsets/headsetBilling/headsetBilling';
import HeadsetEvents from './pages/headsets/headsetEvents/headsetEvents';
import HeadsetUserEvents from './pages/headsets/headsetUserEvents/headsetUserEvents';
import HeadsetPayments from './pages/headsets/headsetPayments/headsetPayments';
import HeadsetComments from './pages/headsets/headsetComments/headsetComments';
import HeadsetLogs from './pages/headsets/headsetLogs/headsetLogs';
import HeadsetBatteryLogs from './pages/headsets/headsetBatteryLogs/headsetBatteryLogs';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />}>
      <Route index element={<AuthPage />} />
      <Route path={MAIN} element={<MainPage />} />
      <Route path={ACCESS_DENIED} element={<AccessDeniedPage />} />
      <Route path={`${REPORTS}/${SALES}`} element={<ReportsSales />} />
      <Route path={`${REPORTS}/${PROBLEMS}`} element={<ReportsProblems />} />
      <Route path={`${REPORTS}/${BILLING}`} element={<ReportsBilling />} />
      <Route
        path={`${REPORTS}/${OFFLINE_HEADSETS}`}
        element={<ReportsOfflineHeadsets />}
      />
      <Route path={`${SERVICE}/${ANALYTICS}`} element={<ServiceAnalytics />} />
      <Route path={`${SERVICE}/${HEADSETS}`} element={<ServiceHeadsets />} />
      <Route
        path={`${SERVICE}/${DEVICE_EVENTS}`}
        element={<ServiceDeviceEvents />}
      />
      <Route path={HOTELS} element={<HotelsPage />} />
      <Route path={`${HOTELS}/:hotel`}>
        <Route index loader={() => redirect(HEADSETS)} />
        <Route path={HEADSETS} element={<HotelHeadsets />} />
        <Route path={METRICS} element={<HotelMetrics />} />
        <Route path={ANALYTICS} element={<HotelAnalytics />} />
        <Route path={BILLING} element={<HotelBilling />} />
        <Route path={ABOUT} element={<HotelAbout />} />
        <Route path={`${HEADSETS}/:headset`}>
          <Route index loader={() => redirect(SETTINGS)} />
          <Route path={SETTINGS} element={<HeadsetSettings />} />
          <Route path={SUBSCRIPTION} element={<HeadsetSubscriptions />} />
          <Route path={BILLING} element={<HeadsetBilling />} />
          <Route path={EVENTS} element={<HeadsetEvents />} />
          <Route path={USER_EVENTS} element={<HeadsetUserEvents />} />
          <Route path={PAYMENTS} element={<HeadsetPayments />} />
          <Route path={COMMENTS} element={<HeadsetComments />} />
          <Route path={META} element={<HeadsetLogs />} />
          <Route path={BATTERY_LOGS} element={<HeadsetBatteryLogs />} />
          <Route path="*" element={<PageNotFound />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Route>,
  ),
);

export const App = () => <RouterProvider router={router} />;

export default App;
